// The flow conversation's contact id, one per console member (aom). The chat SDK keys its
// stored session by this id, so a different member or org in the same browser never sees
// another's thread, and logout (which clears localStorage) starts the member fresh.
// Storage access is best-effort: without it the conversation just won't survive a reload.
const CONTACT_KEY_PREFIX = 'buddy_flow_contact:'

// The runner rejects a contact_identifier that is not a UUID.
const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i

const newUuid = (): string => crypto.randomUUID()

const storageKey = (owner: string): string => `${CONTACT_KEY_PREFIX}${owner}`

export const readContactId = (owner: string): string | null => {
  if (!owner) return null
  try {
    const stored = localStorage.getItem(storageKey(owner))
    return stored && UUID_RE.test(stored) ? stored : null
  } catch {
    return null
  }
}

// Starts a new conversation identity for this member and remembers it.
export const mintContactId = (owner: string): string => {
  const contactId = newUuid()
  if (owner) {
    try {
      localStorage.setItem(storageKey(owner), contactId)
    } catch {
      // Storage full or disabled: the id still works until the page reloads.
    }
  }
  return contactId
}

export const forgetContactId = (owner: string): void => {
  if (!owner) return
  try {
    localStorage.removeItem(storageKey(owner))
  } catch {
    // Nothing stored to forget.
  }
}
